import { Form } from "antd";
import i18n from "i18next";
import { useParams } from "react-router";

import type { FieldMethod, FormFieldFactoryProps } from "../../types/types";
import { TerminalIdCopyGenerator } from "./TerminalIdCopyGenerator";

export const TerminalIdCopyGeneratorField: FieldMethod = ({ field, rules }: FormFieldFactoryProps) => {
    const { id } = useParams();

    return (
        <Form.Item noStyle shouldUpdate={() => true}>
            {({ getFieldValue }) => {
                if (id) {
                    const ORG_UNIT_ID = getFieldValue("orgUnitId");
                    const TERMINAL_ID = +id;

                    const isFieldDisplayed = ORG_UNIT_ID && TERMINAL_ID;

                    return (
                        <Form.Item key={`${field.name}FormItem`} name={field.name} rules={rules}>
                            <TerminalIdCopyGenerator
                                key={field.name}
                                readOnly={!isFieldDisplayed}
                                terminalId={TERMINAL_ID}
                                orgUnitId={ORG_UNIT_ID}
                                label={i18n.t(field.translationKeys.label)}
                                name={field.name}
                            />
                        </Form.Item>
                    );
                }
                return null;
            }}
        </Form.Item>
    );
};
